/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Title_ColInputs */

const en_settings_tickets_title_col = /** @type {(inputs: Settings_Tickets_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const zh_settings_tickets_title_col = /** @type {(inputs: Settings_Tickets_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Settings_Tickets_Title_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_title_col = /** @type {((inputs?: Settings_Tickets_Title_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Title_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_title_col(inputs)
	return zh_settings_tickets_title_col(inputs)
});
export { settings_tickets_title_col as "settings.tickets.title_col" }